import { render } from "./lessonFileGADetail.vue?vue&type=template&id=2824c1ab&scoped=true"
import script from "./lessonFileGADetail.vue?vue&type=script&lang=js"
export * from "./lessonFileGADetail.vue?vue&type=script&lang=js"

import "./lessonFileGADetail.vue?vue&type=style&index=0&id=2824c1ab&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2824c1ab"]])

export default __exports__